<template>
  <div class="messageReminder">
    <div class="titleBox">
      <div class="redBox"></div>
      <p>我的消息提醒</p>
    </div>
    <div class="contair">
      <div class="left">
        <ul>
          <li v-for="(item,index) in menus" :key="index" :class="navActiveIndex === index?'active':''" @click="switchNav(index,item)">{{item.name}}({{item.num}})</li>
        </ul>
      </div>
      <div class="right">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="快捷查询" name="1">
            <div class="top">
              <el-form ref="searchForm" :model="searchForm" label-width="80px">
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="消息标题">
                      <el-input v-model="searchForm.title"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="消息内容">
                      <el-input v-model="searchForm.content"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="创建时间">
                      <el-date-picker v-model="searchdate" :picker-options="pickerOptions" type="datetimerange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <!-- <el-button type="warning">查询</el-button> -->
                    <div class="btn" @click="query()">查询</div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="switchTab">
          <div :class="activeIndex===0?'active':''" @click="switchTab(0)">全部</div>
          <div :class="activeIndex===1?'active':''" @click="switchTab(1)">未读</div>
          <div :class="activeIndex===2?'active':''" @click="switchTab(2)">已读</div>
        </div>
        <div class="tabContent">
          <div>
            <el-table ref="filterTable" :data="tableData" v-loading="searchLoading" v-bind:element-loading-text="searchLoadingText"
              style="width: 100%" @row-click="toggleRowExpansion" @select="onSelect">
              <el-table-column type="selection" width="48">
              </el-table-column>



              <el-table-column v-if="false" label="商品 ID" prop="infoId"></el-table-column>

              <el-table-column label="标题" prop="title" width="606"></el-table-column>

              <el-table-column label="类型" prop="categoryBigName" width="140"></el-table-column>

              <el-table-column label="创建时间" prop="sendTime" width="160"></el-table-column>

              <!-- <el-table-column label="状态" prop="isRead" width="20"></el-table-column> -->

              <el-table-column type="expand" width="80" label="操作">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item class="flenBox">
                      <div class="leftDetail">{{ props.row.content }}</div>
                      <div class="detailBtn" v-if="props.row.callbackUrl!=undefined&&props.row.callbackUrl!=''"><a
                          @click="viewDetail(props.row)">详情</a></div>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>

            </el-table>
          </div>
          <div class="paging">
            <div class="actions">
              <div class="" @click="setRead()">标记已读</div>
              <!-- <div class="" @click="setDelete()">标记删除</div> -->
              <div class="" @click="setAllRead()">全部已读</div>
              <!-- <div class="" @click="setAllDelete()">全部删除</div> -->
            </div>
            <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
              :page-size="100" layout="prev, pager, next, jumper" :total="1000">
            </el-pagination> -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handlePrevClick"
              @next-click="handleNextClick" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default ({
    name: 'messageReminder',
    data() {
      return {
        activeIndex: 0, //消息已读状态 索引
        navActiveIndex: 0, //消息分类（左侧）
        menus: [{
          name: "全部消息",
          value: "MESSAGE_TYPE_ANNOUNCEMENT,MESSAGE_TYPE_FEEDBACK,MESSAGE_TYPE_ORDERNOTIFY,MESSAGE_TYPE_USERLOG,MESSAGE_TYPE_ACCOUNTSECURITY",
          num: 0
        },  {
          name: "个人通知",
          value: "MESSAGE_TYPE_USERLOG",
          num: 0
        },
        //   {
        //   name: "回复通知",
        //   value: "MESSAGE_TYPE_FEEDBACK",
        //   num: 0
        // },
        //   {
        //   name: "订单通知",
        //   value: "MESSAGE_TYPE_ORDERNOTIFY",
        //   num: 0
        // }, {
        //   name: "系统通知",
        //   value: "MESSAGE_TYPE_ANNOUNCEMENT",
        //   num: 0
        // }, {
        //   name: "账户通知",
        //   value: "MESSAGE_TYPE_ACCOUNTSECURITY",
        //   num: 0
        // }
        ],
        querytypes: [{ //消息状态
          name: "全部",
          value: "QUERYLIST_ALL"
        }, {
          name: "未读",
          value: "QUERYLIST_UNREAD"
        }, {
          name: "已读",
          value: "QUERYLIST_READ"
        }],
        searchLoading: false, //列表遮罩
        searchLoadingText: "数据正在加载中，请稍等",
        searchdate: [], //日期范围数组
        searchForm: { //查询参数
          "receiveUserId": this.$store.state.userId,
          // "receiveUserId": 'sysadmin',
          title: '', //消息标题
          content: '', //消息内容
          startDate: '', //开始时间
          endDate: '', //结束时间
          category: '', //消息类别（大类） 值参考：字典中MESSAGE_CATEGORY
          type: '', //消息类型（小类） 值参考：字典中MESSAGE_TYPE
          queryType: 'QUERYLIST_ALL', //查询类型:QUERYLIST_ALL	查询全部(默认值) QUERYLIST_UNREAD	查询未读  QUERYLIST_READ	查询已读
          pageSize: 10,
          pageNo: 1
        },
        tableData: [], //列表行数据
        multipleSelection: [], //列表选中行
        currentPage: 1, //活动页号
        pageSize: 10, //页码大小
        total: 0, //全部/分页数据总数
        isShowSearch: true, //查询参数 显示控制
        activeNames: [''],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    watch: {
      //监听查询日期
      searchdate: function(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.searchForm.startDate = newVal[0].getTime();
          this.searchForm.endDate = newVal[1].getTime();
        } else {
          this.searchForm.startDate = '';
          this.searchForm.endDate = '';
        }
      }
    },
    created: function() {
      //0.统计每个分类消息数量
      this.loadMsgCountAllMsg();

      //1.重置查询参数
      this.resetSearchForm();
      //获取跳转页面参数
      // debugger
      if (this.$route.query.msgType) {
        this.searchForm.type = this.$route.query.msgType;
        this.menus.map((item, index) => {
          if (item.value == this.$route.query.msgType) {
            this.navActiveIndex = index;
            return;
          }
        });
      }
      if (this.$route.query.queryType) {
        this.searchForm.queryType = this.$route.query.queryType;
        this.querytypes.map((item, index) => {
          if (item.value == this.$route.query.queryType) {
            this.activeIndex = index;
            return;
          }
        });
      }

      //2.初始化加载消息列表
      this.queryMsgList();
    },
    methods: {
      query() {
        this.queryMsgList();
      },
      //查询消息列表
      queryMsgList() {
        let this_ = this;
        this_.searchLoading = true;
        let paramdata = {};
        paramdata.data = this_.searchForm;
        paramdata.url = '/SJHG/publicplat/member/msg/msgListSearch';

        paramdata.onSuccess = function(res) {
          this_.searchLoading = false;
          // console.log('-------------通知消息-----------------');
          // console.log(res);
          if (res.data.ok && res.data.result) {

            let count = res.data.result.count;
            let messageList = res.data.result.messageList;

            let pageNo = 1;
            let pageSize = 10;
            let tableData = [];
            if (messageList.length > 0) {

              messageList.map((item, index) => {
                tableData.push({
                  infoId: item.infoId,
                  detailId: item.detailId,
                  title: item.title,
                  sendTime: item.sendTime,
                  content: item.content,
                  sourceSys: item.sourceSys,
                  isRead: item.isRead,
                  categoryBig: item.categoryBig,
                  categoryBigName: item.categoryBigName,
                  categorySmall: item.categorySmall,
                  categorySmallName: item.categorySmallName,
                  operate: '',
                  callbackUrl: item.callbackUrl
                });
              });
              //判断有无查询结果
              if (count === undefined || count === null || count === 'null' || count === 0) {
                count = 0;
              }
            }
            this_.tableData = tableData;
            this_.total = count;
            // categoryBig: "MESSAGE_CATEGORY_ALARM"
            // categorySmall: "MESSAGE_TYPE_FAULT"
            // content: "6号监控视频监控设备获取公网IP失败"
            // detailId: "15857027"
            // infoId: "15857025"
            // isRead: "0"
            // messageCapability: "MESSAGE_CHANNEL_EMAIL,MESSAGE_CHANNEL_BOXMAIL,MESSAGE_CHANNEL_APP"
            // receiveUserId: "sysadmin"
            // receiverId: "15857026"
            // sendTime: "2020-03-25 15:33:24"
            // sendUserId: "sysadmin"
            // sourceSys: ""
            // title: "洪崖洞_6号监控视频监控设备获取公网IP失败"

          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          this_.searchLoading = false;
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      //标记已读
      setRead() {
        this.multipleSelection = this.$refs.filterTable.selection;
        if (this.multipleSelection.length == 0) {
          this.$message({
            message: '请至少勾选一条数据！',
            type: 'warning'
          });
          return false;
        }

        //2.获取infoid
        let messageInfoIds = '';
        this.multipleSelection.map((item, index) => {
          if (messageInfoIds) {
            messageInfoIds += ",";
          }
          messageInfoIds += item.infoId;
        });

        let this_ = this;

        let paramdata = {};
        paramdata.data = {
          "haveReadType": "HAVEREAD_PART_IDS",
          "messageInfoIds": messageInfoIds,
          "receiveUserId": this.searchForm.receiveUserId
        };
        paramdata.url = '/SJHG/publicplat/member/msg/msgSetRead';

        paramdata.onSuccess = function(res) {
          // console.log('-------------部分消息置为已读-----------------');
          // console.log(res);
          if (res.data.ok) {
            this_.query();
          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      //标记已读
      setAllRead() {
        let this_ = this;
        let paramdata = {};
        paramdata.data = {
          "haveReadType": "HAVEREAD_PART_TYPE",
          "type": this.searchForm.type,
          "category": this.searchForm.category,
          "receiveUserId": this.searchForm.receiveUserId
        };
        paramdata.url = '/SJHG/publicplat/member/msg/msgSetRead';

        paramdata.onSuccess = function(res) {
          // console.log('-------------全部消息置为已读-----------------');
          // console.log(res);
          if (res.data.ok) {
            this_.query();
          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      //消息详情查看
      viewDetail(item) {
        // this.$message({
        //   message: '消息详情查看！id=' + vurl,
        //   type: 'info'
        // });
        // return false;
        if (item.callbackUrl) {
          window.open(item.callbackUrl);
        }

      },
      switchTab(index) { //切换消息已读状态
        this.activeIndex = index;
        this.searchForm.queryType = this.querytypes[index].value
        this.query();
      },
      switchNav(index, item) { //切换消息分类
        this.navActiveIndex = index;

        //1.重置查询参数
        this.resetSearchForm();
        //2.设置查询参数
        this.searchForm.type = item.value;
        //3.执行查询
        this.query();
      },
      //重置查询参数
      resetSearchForm() {
        this.searchForm = { //查询参数
          "receiveUserId": this.$store.state.userId,
          // "receiveUserId": 'sysadmin',
          title: '', //消息标题
          content: '', //消息内容
          startDate: '', //开始时间
          endDate: '', //结束时间
          category: '', //消息类别（大类） 值参考：字典中MESSAGE_CATEGORY
          type: this.menus[0].value, //消息类型（小类） 值参考：字典中MESSAGE_TYPE
          queryType: this.querytypes[0].value, //查询类型:QUERYLIST_ALL	查询全部(默认值) QUERYLIST_UNREAD	查询未读  QUERYLIST_READ	查询已读
          pageSize: 10,
          pageNo: 1
        };
        this.activeIndex = 0; //重置消息状态
        this.searchdate = []; //重置日期范围选择器
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      toggleRowExpansion: function(row) {
        this.$refs.filterTable.toggleRowExpansion(row);
      },
      onSelect(selection, row) {
        // console.log('多选');
        // console.log(selection);
        this.multipleSelection = selection;
      },
      handleSizeChange(val) {
        this.pageSize = val;

        this.searchForm.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.pageNo = val;
        this.searchForm.pageNo = val;
        this.query();
      },
      handlePrevClick(val) { //上一页
        this.pageNo = val;
        this.searchForm.pageNo = val;
        this.query();
      },
      handleNextClick(val) { //下一页
        this.pageNo = val;
        this.searchForm.pageNo = val;
        this.query();
      },
      //快捷查询显示控制
      hiddenSearch() {
        if (this.isShowSearch === true) {
          this.isShowSearch = false;
        } else {
          this.isShowSearch = true;
        }
      },
      //0.统计每个分类消息数量
      loadMsgCountAllMsg() {
        let this_ = this;
        let paramdata = {};
        paramdata.data = {
          "type": this.menus[0].value,
          "queryType": "QUERYLIST_ALL",
          // "receiveUserId": 'sysadmin',
          "receiveUserId": this.searchForm.receiveUserId
        };
        paramdata.url = '/SJHG/publicplat/member/msg/msgCountAllMsg';
        paramdata.onSuccess = function(res) {
          // console.log(res.data.result);
          if (res.data.ok) {
            var resultJson = JSON.parse(res.data.result);
            let result = resultJson.result;
            let total = 0; //合计
            this_.menus.map((item, index) => {
              if (result[item.value] != undefined) {
                this_.$set(item, "num", result[item.value]);
                total += Number(result[item.value]);
              }
            });
            this_.$set(this_.menus[0], "num", total);
          } else {
            console.log(res.data);
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);


      }

    }
  })
</script>

<style lang="scss" scoped>
  .el-button {
    border-radius: 0px;
    padding: 9px 20px;
  }

  .top>>>.el-input__inner {
    border-radius: 0px;
    height: 35px;
    line-height: 35px;
  }

  .messageReminder {
    width: 1280px;
    margin: 0 auto;
    margin-top: 20px;
  }

  >>>.el-date-editor .el-range-separator {
    color: #777;
  }

  .left {
    width: 20%;
    border: 1px solid #ccc;
    /* 这个123px后续必需修改，否则有问题 */
    height: calc(100vh - 123px);
  }

  .left ul li {
    cursor: pointer;
  }

  .left ul li.active {
    background: #f5f7fa;
    color: $color-primary;
  }

  .left ul li:hover {
    background: #f5f7fa;
    color: $color-primary;
    cursor: pointer;
  }

  .right {
    flex: 1;
    border: 1px solid #ccc;
    border-left: 0px;
  }

  .right .top {
    margin-top: 10px;
  }

  .top>>>.el-button--warning {
    background: $color-primary;
    border-color: $color-primary;
  }

  .left li {
    padding: 10px 20px;
    color: #222;
  }

  .switchTab {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .switchTab>div {
    padding: 6px 20px;
    background: #f2f2f2;
    margin: 0px 3px;
    border: 1px solid rgba(204, 204, 204, 0.49);
    cursor: pointer;
    color: #666;
    font-size: 14px;
  }

  .switchTab>div:hover {
    color: $color-primary;
  }

  .switchTab>div.active {
    background: $color-primary;
    color: #fff;
    border: 1px solid $color-primary;
  }

  .switchTab>div:last-child {
    margin-right: 0;
  }

  .tabContent>>>.el-table th {
    background: #F2F2F2;
    padding: 10px 0px;
    font-size: 15px;
  }

  .btn {
    background: $color-primary;
    color: #ffffff;
    text-align: center;
    height: 35px;
    line-height: 35px;
    padding: 0px 20px;
    outline: none;
    border: 1px solid $color-primary;
    font-size: 14px;
    margin-left: 10px;
  }

  .btn:hover {
    cursor: pointer;
    background: $color-primary-light-1;
    border: 1px solid $color-primary-light-1;
  }

  >>>.el-form-item__label {
    color: #666;
  }

  .paging {
    display: flex;
    margin-top: 80px;
    border: 1px solid #ccc;
    border-left: none;
    border-right: none;
    align-items: center;
  }

  .paging>>>.el-pagination {
    display: block;
  }

  .paging>>>.el-pager li.active {
    color: $color-primary;
  }

  .paging>>>.el-pager li {
    font-size: 16px;
    font-weight: normal;
    color: #666;
  }

  .actions {
    display: flex;
    align-items: center;
    flex: 1;
    padding-left: 10px;
  }

  .actions>div {
    background: $color-primary;
    color: #fff;
    margin: 3px 5px;
    padding: 5px 8px;
    cursor: pointer;
    font-size: 14px;
  }

  .actions>div:hover {
    background: $color-primary-light-1;
  }

  >>>.el-collapse-item__header {
    height: 35px;
    line-height: 35px;
    padding-left: 10px;
  }

  >>>.el-collapse-item__content {
    padding-bottom: 10px;
  }

  p {
    margin: 0;
    padding: 0;
  }

  .contair {
    display: flex;
    margin-top: 25px;
  }

  .titleBox {
    border-bottom: 1px solid #e6e7ec;
    margin-bottom: 15px;
    display: flex;
  }

  .titleBox>p {
    line-height: 28px;
    height: 32px;
    font-size: 18px;
    color: #222;
  }

  .redBox {
    height: 18px;
    margin-top: 4px;
    background: $color-primary;
    width: 4px;
    margin-right: 4px;
  }

  >>>.el-collapse-item__header {
    color: $color-primary;
    display: block;
  }

  >>>.el-collapse-item__arrow {
    margin-left: 10px;
  }

  .leftDetail {
    width: 875px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 40px;
    line-height: 40px;
  }

  .flenBox>>>.el-form-item__content {
    display: flex;
  }

  .detailBtn {
    height: 40px;
    line-height: 40px;
    width: 28px;
    text-decoration: underline;
    color: $color-primary;
    cursor: pointer;
  }

  >>>.el-table__expanded-cell {
    padding-right: 20px;
  }

  >>>.el-table__row {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/messageReminder.vue